<template>
  <div v-if="show">
    <br />
    <div class="row">
      <ColumnDataValueTotal background="bg-gradient-green" icon="fa fa-money" title="Saldo" :value="conference.balance"
        color="indigo" />
      <ColumnDataValueTotal background="bg-gradient-green" icon="ni ni-money-coins" title="Diferença"
        :value="conference.diff" :color="conference.diff < 0 ? 'red' : conference.diff > 0 ? 'orange' : 'green'" />
    </div>
    <br />
    <el-form label-width="220px">
      <el-row :gutter="5" v-if="conference.diff < 0">
        <el-col :span="24">
          <el-alert :closable="false" type="error" center
            description="Seu caixa está apresentando falta de dinheiro, favor realizar um depósito para regularizar o fechamento">
          </el-alert>
        </el-col>
      </el-row>
      <PdvAuthorization :status="status" v-if="conference.diff < 0" @authorization="$emit('authorization')"
        @refresh="$emit('refresh')" />
      <el-form-item style="text-align: center">
        <el-button type="success" :disabled="conference.diff < 0 && status !== '5'" @click="close()">Fechar o
          caixa</el-button>
      </el-form-item>
    </el-form>
    <el-divider content-position="left">Detalhes do dinheiro em caixa</el-divider>
    <el-table :data="conference.transactions" stripe ref="tablePrepost" size="mini" style="width: 100%"
      :default-sort="{ prop: 'name', order: 'ascending' }">
      <el-table-column width="90" label="Saldo">
        <template slot-scope="scope">{{
          +scope.row.balance
          | currency("R$ ", 2, {
            thousandsSeparator: ".",
            decimalSeparator: ",",
          })
        }}
        </template>
      </el-table-column>
      <el-table-column width="90" label="Valor">
        <template slot-scope="scope">{{
          +scope.row.value
          | currency("R$ ", 2, {
            thousandsSeparator: ".",
            decimalSeparator: ",",
          })
        }}
        </template>
      </el-table-column>
      <el-table-column prop="eventAt" label="Data" />
      <el-table-column prop="description" label="Detalhe" />
    </el-table>
  </div>
</template>
<script>
import { PdvCashierService } from "@/services/pdv/pdv.cashier.services";
import ColumnDataValueTotal from "../../components/data/ColumnDataValueTotal.vue";
import PdvAuthorization from "./cashier/PdvAuthorization.vue";
export default {
  props: ["value", "status"],
  data() {
    return {
      show: false,
      conference: {
        diff: 0,
        balance: 0,
        transactions: [],
      }
    };
  },
  methods: {
    open() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      vm.show = false;
      PdvCashierService.conference(vm.value)
        .then((response) => {
          vm.conference = response.data;
          vm.show = true;
        })
        .catch((error) => this.$message({ type: "error", message: error, offset: 45 }))
        .finally(() => loading.close());
    },
    add(value) {
      const vm = this;
      vm.show = false;
      vm.$emit('add', value);
    },
    close() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      PdvCashierService.close()
        .then((response) => {
          this.$message({ type: "success", duration: 5000, message: 'Caixa fechado com sucesso!', offset: 45 });
          vm.$router.replace({ name: 'pdv' });
        })
        .catch((error) => this.$message({ type: "error", duration: 5000, message: error, offset: 45 }))
        .finally(() => loading.close());
    },
    save() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      PdvService.open(vm.value).then((response) => {
        vm.$store.commit("pdv/id", response);
        this.show = false;
      }).catch((error) => this.$message({ type: "error", duration: 5000, message: error, offset: 45 }))
        .finally(() => loading.close());
    }
  },
  components: { ColumnDataValueTotal, PdvAuthorization }
}
</script>

<style scoped>
.el-alert__title {
  font-size: 13px !important;
}
</style>